var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import OutlinedInput from '../OutlinedInput';
import InputAdornment from '../InputAdornment';
// Helper function for generating border styles
const getBorderStyles = (theme, bdsContainerType, state) => ({
    border: `${theme.palette.select[bdsContainerType].border.width} solid ${theme.palette.select[bdsContainerType].border[state]}`
});
// Styled Select component
const StyledSelect = styled(Select, {
    shouldForwardProp: prop => prop !== 'bdsContainerType'
})(({ theme, bdsContainerType = 'container' }) => {
    return {
        display: 'flex',
        height: '36px',
        width: '100%',
        minWidth: '50px',
        '& .MuiInputAdornment-root': {
            marginRight: 0
        },
        '&.MuiInputBase-root': {
            whiteSpace: 'nowrap',
            padding: bdsContainerType !== 'containerless' ? theme.palette.select[bdsContainerType].padding : 0,
            gap: theme.palette.textField.spaceBetween,
            backgroundColor: theme.palette.select[bdsContainerType].background.default,
            '&::placeholder': { color: 'blue' },
            '&:hover': { backgroundColor: theme.palette.select[bdsContainerType].background.hover },
            '&:focus': { backgroundColor: theme.palette.select[bdsContainerType].background.focus },
            '&.Mui-error': { backgroundColor: theme.palette.select[bdsContainerType].background.error },
            '&.Mui-disabled': {
                backgroundColor: theme.palette.select[bdsContainerType].background.disabled
            }
        },
        '& .MuiInputBase-input': {
            padding: bdsContainerType === 'containerless' ? theme.palette.select[bdsContainerType].padding : 0,
            alignContent: 'center',
            color: theme.palette.select[bdsContainerType].text.default,
            fontFamily: theme.palette.textField.font.family,
            fontSize: theme.palette.textField.font.size,
            fontWeight: theme.palette.textField.font.weight,
            letterSpacing: theme.palette.textField.font.letterSpacing,
            lineHeight: theme.palette.textField.font.lineHeight,
            // TODO: Fix placeholder
            '&::placeholder': { color: theme.palette.textField.placeholder.text.default },
            '&.Mui-disabled': {
                '&::placeholder': { color: theme.palette.textField.placeholder.text.disabled }
            }
        },
        '&.MuiOutlinedInput-root': {
            '& .MuiOutlinedInput-notchedOutline': getBorderStyles(theme, bdsContainerType, 'default'),
            '&.Mui-error': { '& .MuiOutlinedInput-notchedOutline': getBorderStyles(theme, bdsContainerType, 'error') },
            '&.Mui-disabled': {
                '& .MuiOutlinedInput-notchedOutline': Object.assign({ opacity: 1 }, getBorderStyles(theme, bdsContainerType, 'disabled'))
            },
            '&:hover': { '& .MuiOutlinedInput-notchedOutline': getBorderStyles(theme, bdsContainerType, 'hover') },
            '&.Mui-focused': { '& .MuiOutlinedInput-notchedOutline': getBorderStyles(theme, bdsContainerType, 'focus') }
        }
    };
});
const BDSSelect = (_a) => {
    var { bdsContainerType = 'container', error, disabled, label, startIcon } = _a, rest = __rest(_a, ["bdsContainerType", "error", "disabled", "label", "startIcon"]);
    return (React.createElement(StyledSelect, Object.assign({ bdsContainerType: bdsContainerType, error: error, disabled: disabled, input: React.createElement(OutlinedInput, { label: label, startAdornment: startIcon && React.createElement(InputAdornment, { position: "start" }, startIcon) }) }, rest)));
};
BDSSelect.displayName = 'Select';
export default BDSSelect;
//# sourceMappingURL=Select.js.map